$(document).ready(function(){
      $('.cstm-featured-slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: false,
        responsive: [
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 3,
            centerMode: false,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            centerMode: false,
             arrows: true,
            slidesToScroll: 1
          }
        },
         {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
              arrows: true,
            slidesToScroll: 1
          }
        }
      ]
      });

  $('.test_slider').slick({
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  responsive: [
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows:false,
        autoplay: true,
        infinite: true,
        autoplaySpeed: 3000,
        dots: true
      },
    },
  ],
});

 $('.slider-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  fade: true,
   infinite: false,
   adaptiveHeight: true,
    asNavFor: '.slider-nav'

});
$('.slider-nav').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  asNavFor: '.slider-for',
  dots: false,
  arrows: false,
   infinite: false,
  vertical: true,
  verticalSwiping: true,
  focusOnSelect: true,
   responsive: [
    {
      breakpoint: 749,
      settings: {
        vertical: false,
        verticalSwiping: false,
        slidesToShow: 4,
      }
    }
   
    ]
}); 

 $('.product-label_name').click(function(){
    var product_label = $(this).prev('.product_color--label').attr('value');
    $('.form-label__name').text(product_label);
  });




$('.grid_manage .grid_selector').click(function(){
  $(this).addClass('active').siblings().removeClass('active');
  $('#product-grid').attr('class' ,'');
  var selected_class = $(this).attr('data-class')
  $('#product-grid').attr('class' ,selected_class);
});


  
 });

$(window).on('load', function(){
  var product_form_label = $('.product_color--label:checked').attr('value');
  $('.form-label__name').text(product_form_label);

});


